import React, { useCallback, useEffect, useMemo, useState } from 'react'

import {Grid, CircularProgress, TablePagination} from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'

import useStyles from './styles.js'

import Player from './player/Player.js'
import { discipline_all, season_all, getActualSeason, getSeasonDates } from '../../bdd/bddSTUB.js'
import Select_Dsas from '../../dsasComponents/Select_Dsas.js'
import FilterGroupProvider from '../../dsasComponents/FilterGroupProvider.js'
import { isAdminDSAS } from '../../actions/auth.js'
import { fetchCompetitions, fetchPlayers, fetchTeams } from '../../api/index.js'
import { useFetch } from '../../filters/useFetch.js'
import { reload } from '../../filters/reload.js'
import { FETCH_ALL_COMPETITION, FETCH_ALL_PLAYER, FETCH_ALL_TEAM } from '../../constants/actionTypes.js'
import Pagination from '../../dsasComponents/pagination/Pagination.js'

const Players = ( { setCurrentId }) => {
    const classes = useStyles();

    // FILTERS
    const [filters, setFilters] = useState({discipline : '', competition : '', teams : '', provider : '', season : getActualSeason()})

    const [players, loading] = useFetch(fetchPlayers, filters, ['competition', 'teams'], FETCH_ALL_PLAYER)

    const [teams, loadingTeam] = useFetch(fetchTeams, filters, ['competition'], FETCH_ALL_TEAM)

    const competitions_filters = useMemo(() => {
        return {...filters, teams : ''}

    }, [filters])

    const [competitions, loadingCompetition] = useFetch(fetchCompetitions, competitions_filters, undefined, FETCH_ALL_COMPETITION)

    useEffect(() => {
        setFilters(s=> ({...s, competition : '', teams : ''}))
    }, [filters.discipline, filters.season])

    useEffect(() => {
        setFilters(s=> ({...s, teams : ''}))
    }, [filters.competition])

    useEffect(() => {
        const {startDate, endDate} = getSeasonDates(filters.season)
        setFilters(s=> ({...s, startDate, endDate}))
    }, [filters.season])

    return (
        loading ? <CircularProgress /> : (<>
            <div>
            {isAdminDSAS() && <FilterGroupProvider
                        classname={classes.customInput}
                        labelId = {"provider_label"}
                        label = {"Groupe"}
                        selectId = {"provider"}
                        name = {"provider"}
                        filters = {filters} 
                        setFilters = {setFilters}
                    />}
                <Select_Dsas
                            className={classes.selectInput}
                            labelId = {"discipline_label"}
                            label = {"Discipline"}
                            selectId = {"discipline"}
                            name = {"discipline"}
                            value = {filters.discipline}
                            items = {discipline_all}
                            onChange = {(e) => setFilters(state => ({...state, discipline : e.target.value}))}
                            onReset = {(e) => setFilters(state => ({...state, discipline : ''}))}
                />

                <Select_Dsas
                            className={classes.selectInput}
                            labelId = {"season_label"}
                            label = {"Saison"}
                            selectId = {"season"}
                            name = {"season"}
                            value = {filters.season}
                            items = {season_all}
                            onChange = {(e) => setFilters(state => ({...state, season : e.target.value}))}
                            onReset = {(e) => setFilters(state => ({...state, season : ''}))}
                />

                <Select_Dsas
                            isError = {!filters.competition}
                            className={classes.selectInput}
                            labelId = {"competition_label"}
                            label = {"Compétition"}
                            selectId = {"competition"}
                            name = {"competition"}
                            value = {filters.competition}
                            items = {competitions}
                            onChange = {(e) => setFilters(state => ({...state, competition : e.target.value}))}
                            onReset = {(e) => setFilters(state => ({...state, competition : ''}))}
                />

                <Select_Dsas
                            isError = {!filters.teams}
                            className={classes.selectInput}
                            labelId = {"team_label"}
                            label = {"Equipe"}
                            selectId = {"team"}
                            name = {"team"}
                            value = {filters.teams}
                            items = {teams}
                            onChange = {(e) => setFilters(state => ({...state, teams : e.target.value}))}
                            onReset = {(e) => setFilters(state => ({...state, teams : ''}))}
                />

            </div>

            <Pagination items={players} classes={classes}>
                {players.map(player => 
                    <Player key={player._id} player={player} setCurrentId={setCurrentId} reload={() => reload(setFilters)}/>
                )}
            </Pagination>
            </>
        )
        
    )
}

export default Players